import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Form } from "react-bootstrap";
import {
  getWeightText,
  verifyQuantity,
  getProductAmountInCart,
} from "../../helper";
import { FaTrashAlt, FaRupeeSign, FaPencilAlt, FaCheck } from "react-icons/fa";

export default function FinalCartRow(props) {
  const {
    element,
    deleteProductFromCart,
    addToCart,
    isMobile,
    showAlert,
  } = props;
  const [editQuantity, setEditQuantity] = useState(false);
  const [updateValue, setUpdateValue] = useState(element.quantity);
  const [updateComponent, setUpdateComponent] = useState(true);
  const updateQuantityRef = useRef(null);
  const iconSize = isMobile ? 15 : 20;

  useEffect(() => {
    updateValue !== element.quantity &&
      updateComponent &&
      setUpdateValue(element.quantity);
  }, [setUpdateValue, element.quantity, updateValue, updateComponent]);

  return (
    <>
      <Row
        className="text-center final-cart-item"
        key={`final-${element.product_id}-${element.product_name}`}
      >
        <Col
          xs={4}
          className="d-flex justify-content-center align-items-center"
        >
          <p>{element.product_name}</p>
        </Col>
        <Col xs={4} className="d-flex justify-content-center">
          {editQuantity ? (
            <>
              <Form.Control
                className="w-75 text-center"
                ref={updateQuantityRef}
                type="number"
                pattern="\d*"
                value={updateValue}
                style={{ height: isMobile ? "9vw" : "2.7vw" }}
                onChange={(event) => {
                  const { value } = event.target;
                  return setUpdateValue(Number(value));
                }}
              />
              <p>{!element.rate_amt && " Unit"}</p>
            </>
          ) : (
            <div className="d-block">
              <p>
                {element.rate_amt
                  ? getWeightText(Number(element.quantity * element.packaging))
                  : `${element.quantity} Unit`}
              </p>
              <Form.Text className="text-muted text-center">
                {`PKG:
                ${
                  element.rate_amt
                    ? getWeightText(element.packaging)
                    : element.weight
                } 
                ${element.unit ? element.unit : ""}`}
              </Form.Text>
            </div>
          )}
        </Col>
        <Col xs={2} className="d-block">
          <div className="d-flex justify-content-center">
            <FaRupeeSign
              size={iconSize}
              className="mr-1 ml-1 align-self-center"
            />
            <p>{getProductAmountInCart(element)}</p>
          </div>
          <Form.Text className="text-muted text-center d-flex justify-content-center ml-3">
            {element.rate_amt
              ? element.rate_amt + "/KG"
              : element.price_fixed + "/Unit"}
          </Form.Text>
        </Col>
        <Col
          xs={2}
          className="d-flex justify-content-around"
          style={{ height: "max-content", alignSelf: "center" }}
        >
          <FaTrashAlt
            className="update-product-icon"
            size={iconSize}
            onClick={() => deleteProductFromCart(element.product_id)}
          />
          {!editQuantity ? (
            <FaPencilAlt
              className="update-product-icon"
              size={iconSize}
              onClick={async () => {
                await setUpdateComponent(false);
                await setEditQuantity(!editQuantity);
                updateQuantityRef.current.focus();
              }}
            />
          ) : (
            <FaCheck
              className="update-product-icon"
              size={iconSize}
              onClick={() => {
                const result = verifyQuantity(updateValue);
                if (result) {
                  element.rate_amt
                    ? addToCart(element, updateValue || 0, element.packaging)
                    : addToCart(element, updateValue || 0);
                  setUpdateComponent(true);
                  setEditQuantity(false);
                } else {
                  showAlert(
                    "Invalid Quantity",
                    "Only whole numbers are allowed."
                  );
                }
              }}
            />
          )}
        </Col>
      </Row>
      <hr className="sep-3" />
    </>
  );
}
